// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__rR7vG","tableRow":"styles_tableRow__2arcD","tableRowItem":"styles_tableRowItem__eEc0f","viewBtn":"styles_viewBtn__yWVxj"};